import { useEffect, useState } from "react";
import { FileDown, RefreshCw, Timer } from "lucide-react";
import { toast } from "sonner";
import { api, qs } from "@/lib/api";
import { MESI } from "@/lib/format";

/** Mediana del tempo ingresso -> esito in ore lavorative (lun-ven 9-13 / 14:30-18:30), taglio 10%+10%. */
export function TempoRisposta({ filters, puoScaricare = false }) {
  const [d, setD] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    api.get(`/dashboard/tempo-risposta?${qs(filters)}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [filters, tick]);
  const allinea = async () => {
    try {
      const { data } = await api.post("/dashboard/tempo-risposta/allinea");
      toast.success(`Orari: ${data.aggiornate} pratiche aggiornate · ${data.totale_con_orari} con orari · ${data.pratiche_senza_orari - data.aggiornate} senza (es. ${(data.esempi_non_trovati || []).join(", ") || "—"})`, { duration: 12000 });
      if (data.errori_avvio?.length) toast.error(`Errori all'avvio: ${data.errori_avvio.map((e) => `${e.passo}: ${e.errore}`).join(" | ")}`, { duration: 15000 });
      setTick((t) => t + 1);
    } catch (e) { toast.error(e?.response?.data?.detail || "Allineamento non riuscito"); }
  };
  if (!d) return null;
  const m = d.mese_corrente, a = d.anno_intero;
  const meseLbl = (d.dal || d.al)
    ? `${d.dal ? d.dal.split("-").reverse().join("/") : "inizio"} → ${d.al ? d.al.split("-").reverse().join("/") : "oggi"}`
    : MESI[Number(d.mese) - 1] || "";
  return (
    <div data-testid="tempo-risposta-card"
      className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm min-w-[300px]"
      title="Ore lavorative lun–ven 9:00–13:00 / 14:30–18:30, festivi esclusi; ingressi dopo le 17:30 contano dalle 9:00 del giorno lavorativo successivo. Mediana calcolata escludendo il 10% più veloce e il 10% più lento. Escluse le pratiche senza ora ingresso o esito.">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.16em] font-bold text-slate-500">
          <Timer size={13} /> Tempo di risposta ingresso → esito · mediana
        </div>
        {puoScaricare && (<>
          <button type="button" onClick={allinea} data-testid="tempo-risposta-allinea" title="Riapplica gli orari dal file di allineamento alle pratiche senza orario"
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-500 hover:text-[#0018A8]">
            <RefreshCw size={12} /> Allinea orari
          </button>
          <a href={`/api/report/tempo-risposta.pdf?${qs(filters)}`} target="_blank" rel="noreferrer"
            data-testid="tempo-risposta-pdf" title="Scarica il report del trend da inizio anno"
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#0018A8] hover:underline">
            <FileDown size={13} /> Trend PDF
          </a>
        </>)}
      </div>
      <div className="mt-1 flex items-end gap-5">
        <div>
          <div className="text-2xl font-black font-mono text-[#0018A8]" data-testid="tempo-risposta-mediana-mese">
            {m.mediana || "n/d"}
          </div>
          <div className="text-[11px] text-slate-500">{meseLbl} <span className="text-slate-400">· {m.pratiche_valide} su {m.pratiche_totali} pratiche con orari</span></div>
        </div>
        <div className="pb-0.5">
          <div className="text-base font-bold font-mono text-slate-700" data-testid="tempo-risposta-mediana-anno">
            {a.mediana || "n/d"}
          </div>
          <div className="text-[11px] text-slate-500">{d.anno} <span className="text-slate-400">· {a.pratiche_valide} su {a.pratiche_totali} con orari</span></div>
        </div>
      </div>
      <div className="mt-1.5 text-[11px] text-slate-500 space-y-0.5" data-testid="tempo-risposta-fasce">
        {m.fasce.entro_4h !== null && (
          <div>{meseLbl}: entro 2h <b>{m.fasce.entro_2h}%</b> · entro 4h <b>{m.fasce.entro_4h}%</b> · entro 1 giornata <b>{m.fasce.entro_giornata}%</b></div>
        )}
        {a.fasce.entro_4h !== null && (
          <div>{d.anno}: entro 2h <b>{a.fasce.entro_2h}%</b> · entro 4h <b>{a.fasce.entro_4h}%</b> · entro 1 giornata <b>{a.fasce.entro_giornata}%</b></div>
        )}
      </div>
    </div>
  );
}
